var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ParamWrapper',[_c('v-switch',_vm._b({attrs:{"placeholder":_vm.param.name,"hint":_vm.param.description,"persistent-hint":!!_vm.param.description ? true : false,"rules":_vm.fieldRules},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},'v-switch',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }